import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchEcheances } from '../store/slices/coachingsSlice';
import useAutoRefresh from '../hooks/useAutoRefresh';
import { AlertTriangle } from 'lucide-react';

export default function EcheancesPage() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const { echeances, loading } = useSelector(s => s.coachings);

  useEffect(() => { dispatch(fetchEcheances(60)); }, [dispatch]);
  useAutoRefresh(() => fetchEcheances(60), 60000);

  const getUrgence = (d) => {
    const j = Math.round((new Date(d) - new Date()) / 86400000);
    if (j <= 0)  return { badge: 'badge-rouge', label: 'Échu', j };
    if (j <= 15) return { badge: 'badge-rouge', label: `J-${j}`, j };
    if (j <= 30) return { badge: 'badge-orange', label: `J-${j}`, j };
    return { badge: 'badge-bleu', label: `J-${j}`, j };
  };

  const j15 = echeances.filter(e => getUrgence(e.date_fin).j <= 15);
  const j30 = echeances.filter(e => { const {j} = getUrgence(e.date_fin); return j > 15 && j <= 30; });
  const j60 = echeances.filter(e => getUrgence(e.date_fin).j > 30);

  const Section = ({ titre, items, color }) => (
    <div className="table-container" style={{ marginBottom: 20 }}>
      <div className="table-header">
        <div className="table-title" style={{ color }}>
          <AlertTriangle size={16} style={{ marginRight: 6, verticalAlign: 'middle' }} />
          {titre} ({items.length})
        </div>
      </div>
      {items.length === 0 ? <div className="empty-state"><p>Aucun coaching dans cette catégorie</p></div> : (
        <table>
          <thead><tr><th>Client</th><th>Téléphone</th><th>Domaine</th><th>Date fin</th><th>Commercial</th><th>Urgence</th><th>Action</th></tr></thead>
          <tbody>
            {items.map(e => {
              const u = getUrgence(e.date_fin);
              return (
                <tr key={e.id}>
                  <td><strong>{e.client__prenom_cli} {e.client__nom_cli}</strong></td>
                  <td>{e.client__telephone_principal}</td>
                  <td style={{textTransform:'capitalize'}}>{e.domaine?.replace('_',' ')}</td>
                  <td>{new Date(e.date_fin).toLocaleDateString('fr-FR')}</td>
                  <td>{e.commercial_nom || '—'}</td>
                  <td><span className={`badge ${u.badge}`}>{u.label}</span></td>
                  <td><button className="header-btn btn-primary btn-sm" onClick={() => navigate(`/coachings/${e.id}`)}>Voir</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );

  return (
    <div className="page-list">
      <div className="page-header">
        <div></div>
      </div>
      {loading ? <div className="spinner">Chargement...</div> : <>
        <Section titre="🔴 Urgences J-15 et échus" items={j15} color="var(--rouge)" />
        <Section titre="🟠 Alertes J-30"           items={j30} color="var(--orange)" />
        <Section titre="🔵 Préventif J-60"          items={j60} color="var(--bleu2)" />
      </>}
    </div>
  );
}
